import m from "mithril";
import { doublefinLogo } from "./SvgImages";

export const Logo: m.Component = {
  view() {
    return m("div.h-16.w-72", m(doublefinLogo));
  },
};
